export default __webpack_public_path__ + "locales/ar-SA/EmbeddingPanel.json?hash=339ec38fc0ff169bd73cd52b5342b03e";